export const BatchFunctions = "batchFunctions";


// WEBPACK FOOTER //
// ./src/constants/Permissions.ts